import React from 'react';
import { SectionHeader, SectionLabel } from './sections.jsx';

/* ====== Project SVG art ====== */
function ProjectArt({ variant }) {
  const arts = {
    ar: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <defs>
          <linearGradient id="ar-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#d4ff3f" stopOpacity="0.0"/>
            <stop offset="1" stopColor="#d4ff3f" stopOpacity="0.2"/>
          </linearGradient>
        </defs>
        <g transform="translate(300 200)" stroke="#d4ff3f" strokeWidth="1.2" fill="none" opacity="0.9">
          <polygon points="-90,-60 90,-60 90,60 -90,60" />
          <polygon points="-60,-90 120,-90 120,30 -60,30" />
          <line x1="-90" y1="-60" x2="-60" y2="-90" />
          <line x1="90" y1="-60" x2="120" y2="-90" />
          <line x1="90" y1="60" x2="120" y2="30" />
          <line x1="-90" y1="60" x2="-60" y2="30" />
        </g>
        <g stroke="#3a3a3a" strokeWidth="1">
          <line x1="0" y1="200" x2="200" y2="200" />
          <line x1="400" y1="200" x2="600" y2="200" />
          <line x1="300" y1="0" x2="300" y2="120" />
          <line x1="300" y1="280" x2="300" y2="400" />
        </g>
        <g stroke="#d4ff3f" strokeWidth="1.2" fill="none">
          <path d="M 40 40 L 40 60 M 40 40 L 60 40" />
          <path d="M 560 40 L 560 60 M 560 40 L 540 40" />
          <path d="M 40 360 L 40 340 M 40 360 L 60 360" />
          <path d="M 560 360 L 560 340 M 560 360 L 540 360" />
        </g>
        <circle cx="300" cy="200" r="120" fill="none" stroke="#d4ff3f" strokeWidth="0.5" strokeDasharray="2 4" opacity="0.5" />
        <rect x="0" y="0" width="600" height="400" fill="url(#ar-g)" />
      </svg>
    ),
    vr: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <g transform="translate(300 200)">
          {Array.from({ length: 24 }).map((_, i) => {
            const a = (i / 24) * Math.PI * 2;
            return (
              <line key={i}
                x1={Math.cos(a) * 60} y1={Math.sin(a) * 60 * 0.6}
                x2={Math.cos(a) * 140} y2={Math.sin(a) * 140 * 0.6}
                stroke="#d4ff3f" strokeWidth="0.8" opacity={0.3 + ((i * 37) % 100) / 200} />
            );
          })}
          <ellipse cx="0" cy="0" rx="60" ry="36" fill="#0a0a0a" stroke="#d4ff3f" strokeWidth="1.2" />
          <ellipse cx="0" cy="0" rx="140" ry="84" fill="none" stroke="#fff" strokeWidth="0.4" opacity="0.2" />
        </g>
      </svg>
    ),
    ecommerce: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <g>
          <rect x="80" y="80" width="200" height="240" fill="#1a1a1a" stroke="#2a2a2a" />
          <rect x="80" y="80" width="200" height="160" fill="#0d0d0d" />
          <circle cx="180" cy="160" r="40" fill="#d4ff3f" opacity="0.85" />
          <rect x="100" y="260" width="130" height="8" fill="#3a3a3a" />
          <rect x="100" y="280" width="80" height="6" fill="#2a2a2a" />
          <rect x="100" y="300" width="40" height="10" fill="#d4ff3f" />

          <g transform="rotate(4 420 230)">
            <rect x="320" y="110" width="200" height="240" fill="#1a1a1a" stroke="#2a2a2a" />
            <rect x="320" y="110" width="200" height="160" fill="#0d0d0d" />
            <polygon points="380,180 460,180 420,140" fill="#d4ff3f" opacity="0.7" />
            <rect x="340" y="290" width="130" height="8" fill="#3a3a3a" />
            <rect x="340" y="310" width="80" height="6" fill="#2a2a2a" />
          </g>
        </g>
      </svg>
    ),
    pos: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <g>
          <rect x="40" y="50" width="520" height="300" fill="#0d0d0d" stroke="#2a2a2a" />
          <rect x="40" y="50" width="520" height="30" fill="#161616" />
          <circle cx="58" cy="65" r="4" fill="#ff5f56" />
          <circle cx="74" cy="65" r="4" fill="#ffbd2e" />
          <circle cx="90" cy="65" r="4" fill="#27c93f" />
          <rect x="40" y="80" width="120" height="270" fill="#111" />
          <rect x="56" y="100" width="80" height="8" fill="#d4ff3f" />
          <rect x="56" y="120" width="60" height="6" fill="#2a2a2a" />
          <rect x="56" y="135" width="70" height="6" fill="#2a2a2a" />
          <rect x="56" y="150" width="50" height="6" fill="#2a2a2a" />
          <polyline points="180,300 240,260 280,280 320,210 380,230 440,170 500,200 540,150"
            fill="none" stroke="#d4ff3f" strokeWidth="1.5" />
          <polyline points="180,300 240,260 280,280 320,210 380,230 440,170 500,200 540,150 540,340 180,340"
            fill="#d4ff3f" opacity="0.1" />
          <rect x="190" y="120" width="20" height="40" fill="#2a2a2a" />
          <rect x="220" y="100" width="20" height="60" fill="#3a3a3a" />
          <rect x="250" y="130" width="20" height="30" fill="#2a2a2a" />
          <rect x="280" y="110" width="20" height="50" fill="#d4ff3f" opacity="0.3" />
        </g>
      </svg>
    ),
    signage: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <g>
          <rect x="60" y="60" width="180" height="280" fill="#0d0d0d" stroke="#2a2a2a" />
          <rect x="80" y="80" width="140" height="80" fill="#d4ff3f" opacity="0.15" />
          <rect x="80" y="170" width="140" height="6" fill="#d4ff3f" />
          <rect x="80" y="184" width="100" height="6" fill="#3a3a3a" />
          <rect x="80" y="240" width="60" height="40" fill="#1a1a1a" />
          <rect x="150" y="240" width="60" height="40" fill="#1a1a1a" />

          <rect x="270" y="100" width="270" height="160" fill="#0d0d0d" stroke="#2a2a2a" />
          <rect x="290" y="120" width="100" height="80" fill="#d4ff3f" opacity="0.2" />
          <rect x="400" y="120" width="120" height="20" fill="#3a3a3a" />
          <rect x="400" y="150" width="120" height="10" fill="#2a2a2a" />
          <rect x="400" y="166" width="90" height="10" fill="#2a2a2a" />
          <rect x="290" y="220" width="230" height="24" fill="#d4ff3f" />

          <rect x="350" y="280" width="120" height="80" fill="#0d0d0d" stroke="#2a2a2a" />
          <circle cx="410" cy="320" r="20" fill="#d4ff3f" opacity="0.5" />
        </g>
      </svg>
    ),
    civic: (
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <g>
          <path d="M 80 100 Q 200 80 320 120 T 540 110 L 540 320 Q 400 340 240 310 T 80 320 Z"
            fill="#161616" stroke="#2a2a2a" />
          {Array.from({ length: 8 }).map((_, i) => (
            <line key={'h' + i} x1="80" y1={130 + i * 28} x2="540" y2={130 + i * 28} stroke="#2a2a2a" strokeWidth="0.4" />
          ))}
          {Array.from({ length: 10 }).map((_, i) => (
            <line key={'v' + i} x1={120 + i * 48} y1="100" x2={120 + i * 48} y2="320" stroke="#2a2a2a" strokeWidth="0.4" />
          ))}
          {[[180, 180], [310, 220], [420, 170], [240, 270], [460, 290]].map(([x, y], i) => (
            <g key={i}>
              <circle cx={x} cy={y} r="14" fill="none" stroke="#d4ff3f" opacity="0.4">
                <animate attributeName="r" from="6" to="20" dur="2.4s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
                <animate attributeName="opacity" from="0.6" to="0" dur="2.4s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
              </circle>
              <circle cx={x} cy={y} r="5" fill="#d4ff3f" />
            </g>
          ))}
        </g>
      </svg>
    ),
  };
  return <div className="absolute inset-0 flex items-center justify-center transition-transform duration-700 group-hover:scale-[1.04]">{arts[variant] || null}</div>;
}

/* ====== Projects ====== */
function Projects() {
  const items = [
    { idx: '01', title: 'Sutasoma — Virtual Reality',      cat: 'AR / VR · Mobile',        year: '2020', desc: 'Immersive VR storytelling app commissioned to extend the Sutasoma cultural product line. Featured at HANNOVER MESSE international industry expo.', tags: ['Unity', 'VR', 'Android'], art: 'vr',       size: 'lg:col-span-7', bg: 'from-[#14140a] to-[#0d0d0d]' },
    { idx: '02', title: 'Ripos POS — Asia',                cat: 'Point of Sale · Web',     year: '2022', desc: 'Cloud point-of-sale dashboard serving retail clients across Southeast Asia. Real-time inventory, sales analytics, and multi-outlet management.',     tags: ['React', 'PHP', 'MySQL'],  art: 'pos',      size: 'lg:col-span-5', bg: 'from-[#1a1a1a] to-[#0d0d0d]' },
    { idx: '03', title: 'Riglobe Digital Signage',         cat: 'Digital Signage · Singapore', year: '2022', desc: 'Cross-platform digital signage solution for retail displays in Singapore. Remote content scheduling and live deployment fleet management.', tags: ['Web', 'CMS', 'IoT'],      art: 'signage',  size: 'lg:col-span-6', bg: 'from-[#14100d] to-[#0a0a0a]' },
    { idx: '04', title: 'Zamzamy — Augmented Reality',     cat: 'AR · Mobile',             year: '2019', desc: 'AR product visualization for Zamzamy — bringing packaged goods to life through camera-based markers and 3D overlays.',                     tags: ['Unity', 'AR', 'Java'],     art: 'ar',       size: 'lg:col-span-6', bg: 'from-[#0d1410] to-[#0a0a0a]' },
    { idx: '05', title: 'Pasardesa.id',                    cat: 'E-commerce · Civic',      year: '2020', desc: 'Village-scale e-commerce platform built during COVID to stabilize the local economy of Panggungharjo. Connected sellers directly to households.', tags: ['PHP', 'JS', 'MySQL'],     art: 'ecommerce',size: 'lg:col-span-7', bg: 'from-[#14140a] to-[#0d0d0d]' },
    { idx: '06', title: 'Pandowoharjo — Civic Platform',   cat: 'Government · Web',        year: '2020', desc: 'Health monitoring website and community service platform built pro bono for Panggungharjo Village to track and slow COVID spread.',           tags: ['Civic', 'Web', 'Maps'],   art: 'civic',    size: 'lg:col-span-5', bg: 'from-[#1a1a1a] to-[#0d0d0d]' },
  ];

  return (
    <section id="work" className="py-[clamp(96px,14vh,160px)]">
      <div className="max-w-[1320px] mx-auto px-[clamp(20px,4vw,64px)]">
        <SectionHeader label="Selected Work" title="A few things I've shipped." counter="[ 06 of 20+ projects ]" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {items.map((p, i) => (
            <article key={p.idx} className={`reveal rd-${(i % 3) + 1} group ${p.size} col-span-1 relative border border-borderc rounded-xl bg-elev overflow-hidden cursor-pointer transition-colors duration-300 hover:border-borderc-strong`}>
              <div className={`relative overflow-hidden bg-gradient-to-br ${p.bg} aspect-[16/10]`}>
                <div className="absolute inset-0 stripes"></div>
                <ProjectArt variant={p.art} />
                <div className="absolute bottom-[18px] left-[22px] font-mono text-[11px] text-ink-muted tracking-[0.16em] uppercase">PROJECT · {p.idx}</div>
              </div>
              <div className="p-[22px_26px_24px] flex flex-col gap-2.5">
                <div className="flex justify-between items-center font-mono text-[11px] tracking-[0.14em] uppercase text-ink-muted">
                  <span>{p.cat}</span>
                  <span>{p.year}</span>
                </div>
                <div className="text-[clamp(22px,2vw,28px)] font-medium tracking-tighter2 flex justify-between items-center gap-4">
                  <span>{p.title}</span>
                  <span className="text-ink-muted transition-all duration-300 group-hover:text-accent group-hover:translate-x-1 group-hover:-translate-y-1 flex-shrink-0">↗</span>
                </div>
                <div className="text-ink-dim text-[14px] leading-relaxed">{p.desc}</div>
                <div className="flex gap-2 flex-wrap mt-2">
                  {p.tags.map((t, ti) => (
                    <span key={ti} className="font-mono text-[10px] px-2.5 py-1 rounded-full border border-borderc-strong text-ink-dim tracking-wider">{t}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ====== Experience ====== */
function Experience() {
  const roles = [
    {
      period: 'Dec 2021 — Present',
      tag: 'Current',
      role: 'Mobile Developer',
      org: 'Riglobe Pte. Ltd. · Singapore',
      bullets: [
        'Convert from intern to full-time Mobile Developer after delivering on signage and POS-adjacent mobile features.',
        'Build and maintain production mobile applications for retail and digital signage clients across Asia.',
        'Collaborate with the Singapore product team on cross-platform releases and CI workflows.',
      ],
    },
    {
      period: 'Jul 2021 — Nov 2021',
      tag: 'Internship',
      role: 'Mobile Developer Intern',
      org: 'Riglobe Pte. Ltd. · Singapore',
      bullets: [
        'Shipped client-facing mobile features alongside the senior engineering team during a 5-month internship.',
        'Owned a slice of the digital signage companion app — from spec to release on Play Store builds.',
        'Earned full-time conversion at the end of the internship.',
      ],
    },
    {
      period: 'Jan 2021 — Jun 2021',
      tag: 'Frontend',
      role: 'Frontend Developer',
      org: 'PT Rapid Dev · Indonesia',
      bullets: [
        'Built responsive web interfaces for client projects using modern JavaScript, React, and Tailwind.',
        'Partnered with designers to translate Figma flows into production-quality, accessible components.',
        'Worked closely with backend engineers to integrate REST APIs and improve frontend performance.',
      ],
    },
    {
      period: '2020 — Present',
      tag: 'Ongoing',
      role: 'Freelance Developer',
      org: 'Independent · Yogyakarta',
      bullets: [
        'Ship web and mobile builds end-to-end using HTML, CSS, PHP, MySQL, JavaScript, and Java/Android.',
        'Run creative projects concept-to-completion, coordinating outside vendors and stakeholders.',
        'Diagnose and resolve issues across websites, servers, and third-party integrations.',
      ],
    },
    {
      period: 'Mar 2020 — Nov 2020',
      tag: 'Lead',
      role: 'Project Manager',
      org: 'PT Sebangku Jaya Abadi · Yogyakarta',
      bullets: [
        'Built a team to solve the #1 cause of customer complaints — delivered one month ahead of schedule.',
        'Won government investment for the company twice.',
        'Led AR/VR development that earned a HANNOVER MESSE international exhibition slot.',
        'Grew technology division revenue by 20%+.',
      ],
    },
    {
      period: '2020',
      tag: 'Volunteer',
      role: 'Volunteer IT',
      org: 'Panggungharjo Village Government',
      bullets: [
        'Built a health monitoring website to slow the spread of COVID-19 across the village.',
        'Launched Pasardesa — a village-scale e-commerce platform — to stabilize the local economy.',
      ],
    },
    {
      period: '2019 — 2020',
      tag: 'Intern',
      role: 'IT Intern',
      org: 'PT Sebangku Jaya Abadi · Yogyakarta',
      bullets: [
        'Created Augmented Reality applications for Zamzamy product line.',
        'Built AR and VR experiences for Sutasoma — extending the cultural product line.',
        'Improved company branding via company-profile site and Google Business listings.',
      ],
    },
  ];

  return (
    <section id="experience" className="py-[clamp(96px,14vh,160px)] bg-elev">
      <div className="max-w-[1320px] mx-auto px-[clamp(20px,4vw,64px)]">
        <SectionHeader label="Career" title="Where I've worked." counter={`[ ${roles.length} stations · 6+ years ]`} />

        <div className="border-t border-borderc">
          {roles.map((r, i) => (
            <div key={i} className="reveal rd-1 group grid grid-cols-1 md:grid-cols-[200px_1fr_auto] gap-8 py-8 border-b border-borderc items-start transition-colors duration-200 hover:bg-accent/[0.025] relative cursor-default">
              <div className="absolute left-[-1px] top-8 w-1 h-3.5 bg-borderc-strong transition-colors duration-200 group-hover:bg-accent"></div>
              <div className="font-mono text-[12px] text-ink-muted tracking-wider pl-4">{r.period}</div>
              <div>
                <h3 className="text-[clamp(20px,2vw,26px)] font-medium tracking-tight mb-1">{r.role}</h3>
                <p className="text-[14px] text-ink-dim mb-3.5 font-mono">{r.org}</p>
                <ul className="space-y-1.5 list-none p-0">
                  {r.bullets.map((b, bi) => (
                    <li key={bi} className="text-[15px] text-ink-dim leading-relaxed pl-[18px] relative text-pretty before:content-[''] before:absolute before:left-0 before:top-[11px] before:w-2 before:h-px before:bg-accent">
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="font-mono text-[11px] text-ink-muted px-2.5 py-1 border border-borderc rounded-full tracking-wider justify-self-start md:justify-self-auto">{r.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ====== Awards ====== */
function Awards() {
  const items = [
    { year: '2021', desc: 'Nominated for The Asia Pacific ICT Alliance (APICTA) Awards.', level: 'International' },
    { year: '2020', desc: 'Nominated for the ASEAN ICT Award.',                            level: 'Regional' },
    { year: '2019', desc: '1st place — National Canvas Model Business Competition.',       level: 'National' },
    { year: '2018', desc: 'Best Predicate from the best teaching assistant.',              level: 'University' },
    { year: '2016', desc: '2nd place — National E-commerce Website Platform Competition.', level: 'National' },
    { year: '2015', desc: '2nd place — National Robotics Competition.',                    level: 'National' },
  ];
  return (
    <section id="awards" className="py-[clamp(96px,14vh,160px)]">
      <div className="max-w-[1320px] mx-auto px-[clamp(20px,4vw,64px)]">
        <SectionHeader label="Recognition" title="Awards & nominations." counter="[ 06 since 2015 ]" />
        <div className="reveal rd-1 grid grid-cols-1 md:grid-cols-2 gap-px bg-borderc border border-borderc rounded-[10px] overflow-hidden">
          {items.map((a, i) => (
            <div key={i} className="bg-elev px-8 py-7 flex gap-5 items-start transition-colors hover:bg-surface">
              <div className="font-mono text-[28px] text-accent font-medium tracking-tighter2 leading-none min-w-[70px]">{a.year}</div>
              <div className="text-[16px] leading-snug text-pretty flex-1">
                {a.desc}
                <span className="font-mono text-[11px] text-ink-muted tracking-wider uppercase block mt-1.5">{a.level}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ====== Contact ====== */
function Contact() {
  const channels = [
    { label: 'Email',    value: 'adamhanafisyafrudin@gmail.com', href: 'mailto:adamhanafisyafrudin@gmail.com' },
    { label: 'Phone',    value: '+62 896 6170 2136',             href: 'tel:+6289661702136' },
    { label: 'Web',      value: 'ahanafis.com',                   href: 'https://ahanafis.com' },
    { label: 'Location', value: 'Yogyakarta · Singapore',         href: '#' },
  ];
  return (
    <section id="contact" className="pt-[100px] pb-[120px] relative">
      <div className="max-w-[1320px] mx-auto px-[clamp(20px,4vw,64px)]">
        <div className="reveal">
          <SectionLabel>Contact</SectionLabel>
          <h2 className="h-display text-[clamp(56px,9vw,132px)] tracking-tightest leading-[0.92] my-6 mb-14 text-balance">
            Have a project? <br />
            Let's <span className="text-accent">make it</span> real.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-16 items-end mt-20">
          <div className="reveal rd-1 flex flex-col gap-px bg-borderc border border-borderc rounded-lg overflow-hidden">
            {channels.map((c, i) => (
              <a key={i} className="group flex justify-between items-center px-7 py-[22px] bg-elev transition-colors duration-200 hover:bg-accent" href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">
                <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-muted group-hover:text-black/60 transition-colors">{c.label}</span>
                <span className="text-[17px] tracking-tight flex items-center gap-4 group-hover:text-black transition-colors">
                  {c.value}
                  <span className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-black">↗</span>
                </span>
              </a>
            ))}
          </div>

          <div className="reveal rd-2 flex flex-col gap-3.5 py-[22px]">
            <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-muted">Availability</div>
            <div className="flex items-center gap-3 text-[18px]">
              <span className="w-2.5 h-2.5 rounded-full bg-green-400 shadow-[0_0_12px_rgba(74,222,128,0.5)] anim-pulse-dot"></span>
              <span>Open for new projects</span>
            </div>
            <div className="text-ink-dim text-[14px] leading-relaxed max-w-[32ch]">
              Mobile Developer at Riglobe full-time — also taking on selective web and mobile freelance, typically 1‑3 month engagements.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="border-t border-borderc py-9 px-[clamp(20px,4vw,64px)] flex justify-between items-center font-mono text-[12px] text-ink-muted tracking-wide flex-wrap gap-4">
      <div>© 2026 ADAM HANAFI SYAFRUDIN — ALL SYSTEMS GO</div>
      <div>BUILT WITH REACT + THREE.JS + TAILWIND · YOGYAKARTA ↔ SINGAPORE</div>
    </footer>
  );
}

export { Projects, Experience, Awards, Contact, Footer };
